var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-delete-button',{attrs:{"resource":_vm.listState.resource,"plain":"","showIcon":true,"label":_vm.$t('overrides.actions.delete') + " (" + (_vm.listState.selected.length) + ")","color":"primary"},on:{"delete":_vm.onBulkDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }